module.exports = __webpack_public_path__ + "assets/uniicons.2579c7da.ttf";